import React, { useEffect, useState } from 'react'
import emma_w from './../../global/imagenes/emma_w.png';
import { BottomNavigation, BottomNavigationAction, Button, Dialog, DialogActions, DialogContent, FormControl, Grid, InputLabel, List, Menu, MenuItem, Paper, Select, Step, StepLabel, Stepper, TextField } from '@material-ui/core';
import AppBarModal from '../general/AppBarModal';
import TareasTerminadas from '../general/TareasTerminadas';
import { BtnCancelar, BtnCargar, BtnDescargar, BtnForm } from '../general/BotonesAccion';
import { obtenerMisDatos, obtenerPermisosValorAlt, rutaImg, obtenerValores } from '../../global/js/funciones';
import ListarDatos from '../general/ListarDatos';
import PeopleIcon from '@material-ui/icons/People';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import EnviarMultiplesArchivos from '../general/EnviarMultiplesArchivos';
import { REQUISITOS_GRADOS, TIPOS_POSGRADOS } from './helper';
import AlertasSimple from '../general/AlertasSimple';
import BuscarPersona from '../general/BuscarPersona';


const ModalCrearTrabajoGradoPosgrados = ({ opcionGrado, modalAdd, mostrarModalAdd, guardarSolicitud, actualizarMensaje }) => {
    const [cargando, setCargando] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [seleccion, setSeleccion] = useState('integrantes');
    const [cargando_titulo, setCargandoTitulo] = useState('Cargando información...');
    const [programa, setPrograma] = useState({});
    const [programas, setProgramas] = useState([]);
    const [abrirProgramas, setAbrirProgramas] = useState(false);
    const [integrantes, setIntegrantes] = useState([]);
    const [celular, setCelular] = useState('');
    const [solicitante, setSolicitante] = useState({});
    const [requisitos, setRequisitos] = useState([]);
    const [abrirTiposPosgrados, setAbrirTiposPosgrados] = useState(false);
    const [tipoPosgrado, setTipoPosgrado] = useState({});
    const [tiposPosgrados, setTiposPosgrados] = useState([]);
    const steps = ['Datos iniciales', 'Integrantes', 'Requisitos'];
    const [tutores, setTutores] = useState([]);
    const [modalBuscarTutor, setModalBuscarTutor] = useState(false);
    const [modalConfirTutor, setModalConfirTutor] = useState(false);
    const [rolTutor, setRolTutor] = useState('');
    const [abrirRolesTutor, setAbrirRolesTutor] = useState(false);
    const [tutor, setTutor] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            setCargando(true);
            const datos_sesion = await obtenerMisDatos();
            setCelular(datos_sesion.persona.celular);
            setProgramas(datos_sesion.programas);
            setSolicitante({
                id: datos_sesion.persona.id,
                nombre: `${datos_sesion.persona.primer_nombre} ${datos_sesion.persona.primer_apellido} ${datos_sesion.persona.segundo_apellido}`,
                identificacion: datos_sesion.persona.identificacion,
                primer_nombre: datos_sesion.persona.primer_nombre,
                primer_apellido: datos_sesion.persona.primer_apellido,
                segundo_nombre: "",
                segundo_apellido: datos_sesion.persona.segundo_apellido
            });
            setRequisitos(await obtenerPermisosValorAlt([{ 'llave': 'principal', 'valor': 21648 }, { 'llave': 'secundario__generica', 'valor': REQUISITOS_GRADOS }, { 'llave': 'secundario__valora', 'valor': 1 }]));
            setTiposPosgrados(await obtenerValores(TIPOS_POSGRADOS));
            setCargando(false);
        };
        fetchData();
    }, [])
    

    const handleStep = (next) => {
        if (activeStep === 0 && (!celular || Object.keys(programa).length === 0 || Object.keys(tipoPosgrado).length === 0)) {
            actualizarMensaje({ titulo: 'Debe diligenciar todos los campos para poder continuar', tipo: 'info', mostrar: true, tiempo: 2000 });
            return;
        } else if (activeStep === 0) {
            pushSolicitante(solicitante, programa, integrantes);
        }

        if (next) {
            setActiveStep((prev) => prev + 1);
        } else {
            setActiveStep((prev) => prev - 1);
        }
    };

    const pushSolicitante = (persona, programa, integrantes) => {
			let array = integrantes.filter(e => e.id != persona.id);
			let data = { id: persona.id, nombre: persona.nombre, identificacion: persona.identificacion, programa }
			persona.id == solicitante.id ? array.unshift(data) : array.push(data)
			setIntegrantes(array);
	}

    const submit = (archivos) => {
        let tutor_propuesto = tutores.find(e => e.rol == "Tutor Propuesto");
        tutor_propuesto ? tutor_propuesto = tutor_propuesto.nombre : tutor_propuesto = ""
        let data = {
            celular,
            programa: programa.id,
            tipo: opcionGrado.id,
            tipo_posgrado: tipoPosgrado.id,
            tutor_propuesto,
        };
        setCargando(true);
        guardarSolicitud(data, integrantes, () => setCargando(false), archivos, 'posgrados');
    }

    const handleClickSeleccionarTutor = (data) => {
        setTutor({ id: data.id, nombre: `${data.primer_nombre} ${data.primer_apellido}`, identificacion: data.identificacion });
        setModalConfirTutor(true);
    }

    const pushTutor = (persona, rol, tutores) => {
		let array = tutores
		if (array.some(e => e.id == persona.id)) return actualizarMensaje({ titulo: 'Esta persona ya fue seleccionada', tipo: 'info', mostrar: true, tiempo: 3000 });
		if (array.some(e => e.rol == rol)) return actualizarMensaje({ titulo: `Ya cuentas con un ${rol.split(" ")[0]} seleccionado`, tipo: 'info', mostrar: true, tiempo: 3000 });

		let data = { id: persona.id, nombre: persona.nombre, identificacion: persona.identificacion, rol }
		array.push(data)
		setTutores(array);
		setModalConfirTutor(false);
		actualizarMensaje({ titulo: 'Bien, Persona seleccionada', tipo: 'success', mostrar: true, tiempo: 2000 });
	}

    return (
        <>
            <Dialog open={modalAdd} onClose={() => mostrarModalAdd(false)} fullWidth={true} fullScreen={window.innerWidth < 600} maxWidth='sm' aria-labelledby="max-width-dialog-title">
                <AppBarModal titulo={'Trabajo de grado'} mostrarModal={mostrarModalAdd} titulo_accion="" accion="" />
                <DialogContent className='scroll' >
                    {!cargando ?
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <Stepper activeStep={activeStep}>
                                    {steps.map(label => (
                                        <Step key={label}>
                                            <StepLabel><p>{label}</p></StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                < Menu sele={seleccion} seleccionar={seleccion => setSeleccion(seleccion)} />
                                {
                                    (() => {
                                        switch (activeStep) {
                                            case 0:
                                                return <DatosIniciales celular={celular} setCelular={setCelular} abrirProgramas={abrirProgramas} setAbrirProgramas={setAbrirProgramas} programa={programa} setPrograma={setPrograma} setIntegrantes={setIntegrantes} programas={programas} tipoPosgrado={tipoPosgrado} setTipoPosgrado={setTipoPosgrado} tiposPosgrados={tiposPosgrados} abrirTiposPosgrados={abrirTiposPosgrados} setAbrirTiposPosgrados={setAbrirTiposPosgrados} />;
                                            case 1:
                                                return <Integrantes integrantes={integrantes} solicitante={solicitante} setIntegrantes={setIntegrantes} seleccion={seleccion} setSeleccion={setSeleccion} tutores={tutores} setTutores={setTutores} setModalBuscarTutor={setModalBuscarTutor} />;
                                            case 2:
                                                return <Requisitos requisitos={requisitos} submit={submit} />;
                                            default:
                                                return null;
                                        }
                                    })()
                                }
                            </Grid>
                        </Grid>
                        :
                        <div>
                            <TareasTerminadas imagen={emma_w} mensaje={cargando_titulo} widthImg='7%' marginTop='7%' cargando={true} />
                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    {!cargando && (
                        activeStep == 0 ?
                            <BtnForm texto="SIGUIENTE" callback={() => handleStep(true)} type="submit" /> :
                            activeStep == 2 ?
                                <div>
                                    <BtnForm texto="ATRAS" callback={() => handleStep(false)} />
                                    <BtnForm texto="ENVIAR" callback={() => { document.getElementById('enviar_form_multi_archivo').click() }} />
                                </div> :
                                <div>
                                    <BtnForm texto="ATRAS" callback={() => handleStep(false)} />
                                    <BtnForm texto="SIGUIENTE" callback={() => handleStep(true)} type="submit" />
                                </div>)
                    }
                </DialogActions>
            </Dialog>
            <Dialog onClose={() => setModalBuscarTutor(false)} open={modalBuscarTutor} fullWidth={true} maxWidth="sm" fullScreen={window.innerWidth < 600}>
                <AppBarModal titulo={'Buscar Tutores'} mostrarModal={() => setModalBuscarTutor(false)} />
                <DialogContent style={{ padding: '0' }} className='scroll'>
                    <BuscarPersona callback={(data) => handleClickSeleccionarTutor(data)} />
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
            <Dialog open={modalConfirTutor} fullWidth={true} maxWidth="xs" onClose={() => setModalConfirTutor(false)} aria-labelledby="form-dialog-title">
                <AppBarModal titulo={"¿Seleccionar Tutor?"} mostrarModal={() => setModalConfirTutor(false)} titulo_accion="" accion="" />
                <DialogContent className='scroll'>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField id={'tutor'} name={'tutor'} label={'Nombre'} defaultValue={tutor.nombre} fullWidth autoComplete="billing address-line1" value={tutor.nombre} disabled />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <FormControl className="form-control">
                                <InputLabel shrink required={true}>Rol</InputLabel>
                                <Select open={abrirRolesTutor} onClose={() => setAbrirRolesTutor(false)} onOpen={() => setAbrirRolesTutor(true)} value={rolTutor} onChange={(e) => setRolTutor(e.target.value)} labelid="demo-simple-select-placeholder-label-label" id="demo-simple-select-placeholder-label" >
                                    <MenuItem key={1} value={"Tutor Propuesto"}>Tutor Propuesto</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Button color="primary" type="submit" id='enviar_form_add_archivo' className="oculto"> Guardar </Button>
                </DialogContent>
                <DialogActions>
                    <BtnForm texto="CANCELAR" callback={() => setModalConfirTutor(false)} />
                    <BtnForm texto="SELECCIONAR" callback={() => {
                        if (tutor.id > 0 && rolTutor) pushTutor(tutor, rolTutor, tutores)
                        else actualizarMensaje({ titulo: 'Seleccione un rol', tipo: 'info', mostrar: true, tiempo: 2000 });
                    }}
                    />
                </DialogActions>
            </Dialog>
        </>
    )
}

const DatosIniciales = ({ celular, setCelular, abrirProgramas, setAbrirProgramas, programa, setPrograma, setIntegrantes, programas, abrirTiposPosgrados, setAbrirTiposPosgrados, tipoPosgrado, setTipoPosgrado, tiposPosgrados }) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
                <TextField type="number" id={'celular'} name={'celular'} label={'Celular'} defaultValue={celular} fullWidth autoComplete="billing address-line1" onChange={(e) => setCelular(e.target.value)} value={celular} required />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <FormControl className="form-control">
                    <InputLabel shrink required={true}>Programa</InputLabel>
                    <Select
                        open={abrirProgramas}
                        onClose={() => setAbrirProgramas(false)}
                        onOpen={() => setAbrirProgramas(true)}
                        value={programa.id}
                        onChange={(e) => {
                            setPrograma({ id: e.target.value, nombre: e.nativeEvent.srcElement.attributes.name.value });
                            setIntegrantes([]);
                        }}
                        labelid="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label" >
                        {programas.map(({ relacion: { id, nombre } }) => <MenuItem key={id} value={id} name={nombre}>{nombre}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <FormControl className="form-control">
                    <InputLabel shrink required={true}>Tipos de posgrados</InputLabel>
                    <Select
                        open={abrirTiposPosgrados}
                        onClose={() => setAbrirTiposPosgrados(false)}
                        onOpen={() => setAbrirTiposPosgrados(true)}
                        value={tipoPosgrado.id}
                        onChange={(e) => {
                            setTipoPosgrado({ id: e.target.value, nombre: e.nativeEvent.srcElement.attributes.name.value });
                        }}
                        labelid="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label" >
                        {tiposPosgrados.map((valor) => <MenuItem key={valor.id} value={valor.id} name={valor.nombre}>{valor.nombre}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    )
}

const Integrantes = ({ integrantes, solicitante, setIntegrantes, seleccion, setSeleccion, tutores, setTutores, setModalBuscarTutor }) => {
    const clase = (item, selec, tipo = '') => item === selec ? `item_selec${tipo}` : `item_modulo`;
    return (
        <>
            <div className={'menu_modal'}>
                <BottomNavigation showLabels >
                    <BottomNavigationAction label={'Participantes'} icon={<PeopleIcon />} className={clase("integrantes", seleccion)} onClick={() => setSeleccion('integrantes')} />
                    <BottomNavigationAction label={'Tutores'} icon={<SupervisorAccountIcon />} className={clase("tutores", seleccion)} onClick={() => setSeleccion('tutores')} />
                </BottomNavigation>
            </div>
            {
                seleccion == 'integrantes' ?
                    <Grid container spacing={3} className='scroll'>
                        <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                            <ListarDatos
                                datos={integrantes}
                                avatarImg={true}
                                avatar={({ identificacion }) => `${rutaImg}${identificacion}.jpg`}
                                acciones={(row) => {
                                    return solicitante.id != row.id && <BtnCancelar texto='Quitar' callback={() => { setIntegrantes(integrantes.filter(e => e.id != row.id)) }} />
                                }}
                                fila_principal={({ nombre }) => nombre}
                                filas={[{ 'mostrar': ({ programa }) => programa && programa.nombre },]}
                                css={{}}
                            />
                        </Grid>
                    </Grid>
                    :
                    <Grid container spacing={3} className='scroll'>
                        <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                            {
                                tutores.length > 0 &&
                                <ListarDatos
                                    datos={tutores}
                                    avatarImg={true}
                                    avatar={({ identificacion }) => `${rutaImg}${identificacion}.jpg`}
                                    acciones={(row) => {
                                        return <BtnCancelar texto='Quitar' callback={() => setTutores(tutores.filter(e => e.id != row.id))} />;
                                    }}
                                    fila_principal={({ nombre }) => nombre.toUpperCase()}
                                    filas={[{ 'mostrar': ({ rol }) => rol && rol.toUpperCase() },]}
                                    css={{}}
                                />
                            }
                            <AlertasSimple callback={() => setModalBuscarTutor(true)} tipo='info' titulo='¿Tutores propuestos?' sub_titulo={"Clic aquí para buscar y sugerir tus tutores de grado, los cuales podrán ser tenidos en cuenta para su proceso. De lo contario puede omitir este paso"} />
                        </Grid>
                    </Grid>
            }
        </>
    )
}

const Requisitos = ({ requisitos, submit }) => {
    const trasnformarDataAdj = (data) => {
        let r = [];
        data.map(({ secundario }) => r.push({ nombre: secundario.nombre, descripcion: secundario.descripcion, codigo: secundario.id, archivo: secundario.archivo }))
        return r;
    }

    const acciones = (data, callback) => {
        const onClickCargar = (data) => callback(data);
        const onClickDescargar = ({ archivo }) => {
            if (archivo) window.open(`${archivo}`, '_blank')
        }

        let descargar = data.archivo && <BtnDescargar callback={() => onClickDescargar(data)} color='#01579b' texto='Abrir' />
        let cargar = <BtnCargar callback={() => onClickCargar(data)} color='#00bfa5' texto='Gestionar' />

        return <div>{descargar} {cargar}</div>;
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Paper elevation={0} square>
                    <List component="nav" arial-label="main">
                        <EnviarMultiplesArchivos
                            enModal={false}
                            enviarArchivos={(archivos) => submit(archivos)}
                            limite={2}
                            mostrarMensaje={false}
                            enLista={true}
                            lista={trasnformarDataAdj(requisitos)}
                            acciones={acciones}
                        />
                    </List>
                </Paper>
            </Grid>
        </Grid>
    )
}


export default ModalCrearTrabajoGradoPosgrados